import { render, staticRenderFns } from "./ParecerFinanceiro.vue?vue&type=template&id=71b94994"
import script from "./ParecerFinanceiro.vue?vue&type=script&lang=js"
export * from "./ParecerFinanceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports